import React from 'react';
import Button from '@atlaskit/button/standard-button';
export default function Navigator(props) {
  return /*#__PURE__*/React.createElement(Button, {
    "aria-label": props['aria-label'],
    isDisabled: props.isDisabled,
    iconBefore: props.iconBefore,
    testId: props.testId,
    onClick: props.onClick,
    component: props.component,
    appearance: "subtle"
  });
}